/* @flow */
import * as React from 'react';

import Styled from './styled';

type Props = {
  description: string,
  value: string,
  isFirstRow?: boolean,
  isPrimary?: boolean,
};

class PriceSummaryRow extends React.PureComponent<Props, void> {
  render() {
    const { description, value, isFirstRow, isPrimary } = this.props;
    return (
      <Styled.Row isFirstRow={isFirstRow} isPrimary={isPrimary}>
        <Styled.Description>{description}</Styled.Description>
        <Styled.Price>{value}</Styled.Price>
      </Styled.Row>
    );
  }
}

export default PriceSummaryRow;
